"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackOpenPromoBannerDescription = void 0;
const enums_1 = require("../enums");
const trackGA4EventWithCleanUp_1 = require("./trackGA4EventWithCleanUp");
function trackOpenPromoBannerDescription(clickText, clickElement) {
    const eventData = {
        eventName: enums_1.GA4EventName.ClickTextLink,
        feature_category: enums_1.GA4FeatureCategory.CustomerAccount,
        click_element: clickElement,
        click_text: clickText,
    };
    (0, trackGA4EventWithCleanUp_1.trackGA4EventWithCleanUp)({
        eventData,
    });
}
exports.trackOpenPromoBannerDescription = trackOpenPromoBannerDescription;
//# sourceMappingURL=trackOpenPromoBannerDescription.js.map